import React from 'react';

const ErrorIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-inactive-red" />
    </div>
  );
};

export default ErrorIcon;
